<div class="container">
  <div class="edition">
    <storever-edit-options *ngIf="isData"
                           [dataConfig]="dataConfig"
                           [itemUpdate]="itemUp"
                           [form]="form"
    ></storever-edit-options>
  </div>
  <div class="options">
    <storever-add-options
     (addOptionItem)="addOption($event)"
    ></storever-add-options>
  </div>
</div>
<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre>dataConfig.form: {{dataConfig?.form?.value | json}} </pre>
  <pre>dataConfig.groupConfigs: {{dataConfig?.groupConfigs | json}} </pre>
<!--  <pre>dataConfig.content: {{dataConfig.content}} </pre>-->
</div>
